import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import PUBLIC_ROUTES from './routes/PublicRoutes'
import PRIVATE_ROUTES from './routes/PrivateRoutes'
import AuthProvider from "./context/AuthProvider";

// core styles
import "./scss/volt.scss";

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";

const renderRoute = (route, index) => {

    const Middleware = route.middleware;

    return <Middleware
        key={index}
        layout={route.layout}
        path={route.path}
        component={route.component}
        title={route.title}
        exact={route.exact}
    />
}


ReactDOM.render(

  <BrowserRouter>
                  <AuthProvider>

    <Switch>
        {
            Object.keys(PRIVATE_ROUTES).map((key, index) => (renderRoute(PRIVATE_ROUTES[key], index)))
        }
        {
            Object.keys(PUBLIC_ROUTES).map((key, index) => (renderRoute(PUBLIC_ROUTES[key], index)))
        }
        {/*<Route component={Page404}/>*/}
    </Switch>
                                              </AuthProvider>

  </BrowserRouter>,

  document.getElementById("root")
);
